var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionCalendar18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.5c-.413 0-.766-.147-1.06-.44A1.446 1.446 0 012.25 15V4.5c0-.412.147-.765.44-1.059A1.445 1.445 0 013.75 3h.75V1.5H6V3h6V1.5h1.5V3h.75c.412 0 .766.147 1.06.441.293.294.44.647.44 1.059V15c0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44H3.75zm0-1.5h10.5V7.5H3.75V15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionCalendar18);
export default __webpack_public_path__ + "4d24c54db10236e0bf917f4b27612870.svg";
export { ForwardRef as ReactComponent };